import { useEffect } from "react";
import { pdfjs } from "react-pdf";

let workerInitialized = false;

const resolvedWorkerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

export function usePdfWorker() {
  useEffect(() => {
    if (workerInitialized) {
      return;
    }

    pdfjs.GlobalWorkerOptions.workerSrc = resolvedWorkerSrc;
    workerInitialized = true;
  }, []);
}

